define([
	"dojo/_base/declare",
	"csi/action/ManageController",
	"csi/reflection",
	"csi/xml"
], function(declare, ManageController, reflection, xml) {

	return declare(ManageController, {
		toWriter: function() {
			// summary: set attribute flags on delete
			if (this.m_bToggle) {
				// deleting the node, not creating it
				// when deleting the node, set QuoteBOM and QuoteRouting to their reflection model setting for the read-only flag
				var rc = reflection.getClass("SupplierItemRevision");
				var readOnlyQuoteRouting = rc?.getRelation("QuoteRouting").isReadOnly;
				var readOnlyQuoteBOM = rc?.getRelation("QuoteBOM").isReadOnly;

				this.m_writer.changeNode(xml.getUrlPath(this.m_urlNode, xml.PATH_PARENT))
					.changeAttributeFlag("QuoteRouting", xml.ATTR_FLAG_NOEDIT, readOnlyQuoteRouting, !readOnlyQuoteRouting)
					.changeAttributeFlag("QuoteBOM", xml.ATTR_FLAG_NOEDIT, readOnlyQuoteBOM, !readOnlyQuoteBOM);
			}

			this.inherited(arguments);
		}
	});
});